import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { deleteSingleMaterial } from '../../../Store/PHPSlice/Material';



const TableBody = ({
    id,
    materialNm,
    description,
    size,
    packets,
    packetqty,
    totqty,
    locId,
    locNm,
    serialNumber,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/MaterialEdit/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    const handleDeleteClick = () => {
        // Show confirmation dialog
        const isConfirmed = window.confirm("Are you sure you want to delete this Material?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            dispatch(deleteSingleMaterial(id))
                .then(() => {
                    // Reload the page to show updated results
                    toast.success("Material Deleted Sucessfully");
                    window.location.reload();
                })
                .catch((error) => {
                    // Handle any errors that occur during the deletion process
                    console.error("Error deleting company:", error);
                    toast.error("Failed to delete company");
                });
        }
    };





    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{serialNumber}</TableCell>

                <TableCell component="th" scope="row" sx={{ p: 1, border: '1px solid #000' }} align='center'>

                    <Typography variant="subtitle2" noWrap>
                        {locNm}
                    </Typography>

                </TableCell>

                <TableCell component="th" scope="row" sx={{ p: 1, border: '1px solid #000' }} align='center'>

                    <Typography variant="subtitle2" noWrap>
                        {materialNm}
                    </Typography>

                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{description}</TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{size}</TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{packets}</TableCell>
                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{packetqty}</TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{totqty}</TableCell> */}

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <EditIcon className="cursor-pointer" onClick={handleEditClick} />
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <DeleteIcon className="cursor-pointer" onClick={handleDeleteClick} />
                </TableCell>
            </TableRow>
            <ToastContainer />
        </>
    );
};

export default TableBody;
